export default __webpack_public_path__ + "static/media/2.4402d5e3.svg";